import { getRewardById } from '@vista/omnichannel-components-domain';
import { compareDateCountdown, getCountdownForDate } from '../../../utils/date-utils';
import { compare } from '../../../utils/sort-utils';
import { getAvailableQuantityLimit } from './get-available-quantity-limit';
import { getRewardDateCountdown } from './get-reward-date-countdown';
export const sortRewards = (rewards, config) => {
    const { rewardFilterFn } = config;
    const sortedRewards = [...rewards].sort(compareRewards(config));
    const filteredRewards = rewardFilterFn ? rewardFilterFn(sortedRewards) : sortedRewards;
    return filteredRewards;
};
const compareRewards = (config) => {
    return (rewardA, rewardB) => {
        const a = getRewardSortDetails(rewardA, config);
        const b = getRewardSortDetails(rewardB, config);
        // Rewards with an expiry tag (closer to expired at top)
        if (a.hasExpiryTag !== b.hasExpiryTag)
            return a.hasExpiryTag ? -1 : 1;
        if (a.hasExpiryTag && b.hasExpiryTag) {
            const result = compareDateCountdown(true, true)(a.expiryDateCountdown, b.expiryDateCountdown);
            if (result !== 0)
                return result;
        }
        // Rewards with a quantity tag (less quantity at top)
        if (a.hasQuantityTag !== b.hasQuantityTag)
            return a.hasQuantityTag ? -1 : 1;
        if (a.hasQuantityTag && b.hasQuantityTag) {
            const result = compare(a.availableQuantity, b.availableQuantity);
            if (result !== 0)
                return result;
        }
        // Rewards with tags that were equally matched use alphabetical sorting as a tie-breaker.
        // Rewards without tags are sorted alphabetically.
        return a.name.text.localeCompare(b.name.text);
    };
};
const getRewardSortDetails = (memberReward, config) => {
    const { rewardId, expiresAt, availableQuantity: rewardAvailableQuantity } = memberReward;
    const reward = getRewardById(rewardId);
    const expiryDateLeft = expiresAt ? getCountdownForDate(new Date(expiresAt)) : undefined;
    const availableQuantity = getAvailableQuantityLimit(rewardAvailableQuantity, config.quantityTagThreshold);
    const expiryDateCountdown = getRewardDateCountdown(expiryDateLeft, config.expiryTagThresholdInDays);
    if (!reward)
        throw Error(`No reward found with rewardId '${rewardId}'.`);
    return {
        name: reward.name,
        hasQuantityTag: !!availableQuantity,
        availableQuantity,
        hasExpiryTag: !!expiryDateCountdown,
        expiryDateCountdown
    };
};
